/*
import { getMessaging, getToken } from 'firebase/messaging'

export default ({ $axios, $confirm, app, store }, inject) => {
    inject('notificationPropmt', () => {
        setTimeout(() => {
            if (store.state.user && store.state.user.id && Notification && Notification.permission !== 'denied' && !document.cookie.includes('notificationsDenied')) {
                if (Notification.permission !== 'granted') {
                    $confirm(app.i18n.t('app.notificationPropmt')).then((a) => {
                        if (a) {
                            saveToken()
                        } else {
                            const d = new Date()
                            d.setFullYear(d.getFullYear() + 5)
                            document.cookie = 'notificationsDenied=1; expires=' + d.toUTCString()
                        }
                    })
                } else {
                    saveToken()
                }
            }

            function saveToken () {
                const messaging = getMessaging()

                getToken(messaging, { vapidKey: 'BLwQHtWy4dUx4nyPkW8IkHFP2jVGkGRgMzYFN-d7GNUdD3AwaC3u4QushC7HOkMOVMeYGy2rLuBF78Miz4yU_2I' }).then((currentToken) => {
                    if (currentToken) {
                        $axios.post('/be/push/saveToken', { token: currentToken }).then(() => {

                        })
                    }
                }).catch((err) => { console.error(err) })
            }
        }, 10000)
    })
    inject('notificationEnable', () => {
        if (store.state.user && store.state.user.id && Notification && Notification.permission !== 'denied' && !document.cookie.includes('notificationsDenied')) {
            if (Notification.permission !== 'granted') {
                saveToken()
            } else {
                saveToken()
            }
        }

        function saveToken () {
            const messaging = getMessaging()

            getToken(messaging, { vapidKey: 'BLwQHtWy4dUx4nyPkW8IkHFP2jVGkGRgMzYFN-d7GNUdD3AwaC3u4QushC7HOkMOVMeYGy2rLuBF78Miz4yU_2I' }).then((currentToken) => {
                if (currentToken) {
                    $axios.post('/be/push/saveToken', { token: currentToken }).then(() => {

                    })
                    localStorage.setItem('fcmtoken', currentToken)
                }
            }).catch((err) => { console.error(err) })
        }
    })
    inject('notificationDisable', () => {
        const messaging = getMessaging()
        getToken(messaging, { vapidKey: 'BLwQHtWy4dUx4nyPkW8IkHFP2jVGkGRgMzYFN-d7GNUdD3AwaC3u4QushC7HOkMOVMeYGy2rLuBF78Miz4yU_2I' }).then((currentToken) => {
            if (currentToken) {
                $axios.post('/be/push/deleteToken', { token: currentToken }).then(() => {

                })
            }
        }).catch((err) => { console.error(err) })
    })
}
*/